export function getTeacherAuthHeaders(includeJsonContentType = false) {
  return {
    Accept: "*/*",
    ...(includeJsonContentType ? { "Content-Type": "application/json" } : {}),
  };
}

/** Cavabdan siyahı çıxarır (müxtəlif backend formatları üçün). */
export function unwrapArrayPayload(data, candidateKeys) {
  if (Array.isArray(data)) return data;
  if (!data || typeof data !== "object") return [];
  for (const key of candidateKeys) {
    const v = data[key];
    if (Array.isArray(v)) return v;
  }
  return [];
}
